/**
 * AGM UIDs are integers end to end (Uid INT in SQL, `uid: number` in TS).
 * A bare `Array.prototype.sort()` compares them as strings, so 10 would sort
 * before 9. Always compare numerically.
 *
 * Returns a new array; the input (often a store-backed list) is not mutated.
 */
export function sortUidsAscending(uids: readonly number[]): number[] {
  return [...uids].sort((a, b) => a - b);
}

/**
 * Same rule for lists of objects (devices, `{ label, value }` select options):
 * sort by the numeric UID that `uidOf` selects, never by a label such as
 * 'AGM UID 10', which would sort lexically.
 *
 * Returns a new array; the input is not mutated.
 */
export function sortByUidAscending<T>(
  items: readonly T[],
  uidOf: (item: T) => number
): T[] {
  return [...items].sort((a, b) => uidOf(a) - uidOf(b));
}
